import {
  PAYMENT_TYPE_ALL,
  PAYMENT_TYPE_GET,
  PAYMENT_TYPE_DEL,
  PAYMENT_TYPE_PUT,
  PAYMENT_TYPE_POST,
  PAYMENT_TYPE_LOADING,
  PAYMENT_TYPE_ERROR,
} from '../../actions/types';

const initialState = {
  paymentType: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PAYMENT_TYPE_LOADING:
      return { isLoading: true, isCompleted: true };
    case PAYMENT_TYPE_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case PAYMENT_TYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYMENT_TYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYMENT_TYPE_POST:
      return { isLoading: false, isCompleted: true };
    case PAYMENT_TYPE_PUT:
      return { isLoading: false, isCompleted: true };
    case PAYMENT_TYPE_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
